module.exports = __webpack_public_path__ + "img/FreelancerCircleSmartphone.782df9a1.webp";